/**
 * LineChartEditor
 *
 * Property editor for line chart configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { SelectPropertyEditor } from '../../BaseEditors/SelectPropertyEditor';
import { CheckboxPropertyEditor } from '../../BaseEditors/CheckboxPropertyEditor';

export interface LineChartEditorProps {
  config: Partial<ChartBaseConfig & {
    interpolation?: 'linear' | 'spline' | 'step';
    showDots?: boolean;
    showGrid?: boolean;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const LineChartEditor: React.FC<LineChartEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Line Chart" showAxes>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Line Chart Options</h3>

        <SelectPropertyEditor
          label="Line Interpolation"
          value={config.interpolation || 'linear'}
          onChange={(interpolation) => onChange({ ...config, interpolation })}
          options={[
            { value: 'linear', label: 'Linear' },
            { value: 'spline', label: 'Spline (Curved)' },
            { value: 'step', label: 'Step' },
          ]}
          helpText="How to connect data points"
        />

        <div className="chart-editor__checkbox">
          <input
            type="checkbox"
            id="show-dots"
            checked={config.showDots !== false}
            onChange={(e) => onChange({ ...config, showDots: e.target.checked })}
            className="af-property-editor__checkbox"
          />
          <label htmlFor="show-dots" className="af-property-editor__label">
            Show Data Points (Dots)
          </label>
        </div>

        <div className="chart-editor__checkbox">
          <input
            type="checkbox"
            id="show-grid"
            checked={config.showGrid !== false}
            onChange={(e) => onChange({ ...config, showGrid: e.target.checked })}
            className="af-property-editor__checkbox"
          />
          <label htmlFor="show-grid" className="af-property-editor__label">
            Show Grid Lines
          </label>
        </div>
      </div>
    </ChartBaseEditor>
  );
};

LineChartEditor.displayName = 'LineChartEditor';
